// extracted by mini-css-extract-plugin
module.exports = {"deadline":"Make1099When_deadline__TtHWT","deadline__title":"Make1099When_deadline__title__m5TPa"};